/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready(function () {
  var intervalID;
  var urlPath = window.location.pathname;

  if (urlPath.indexOf("wholesale-order-form") > -1) {
    console.log("wholesale order form");

    $("table .quantity:first").focus();
    $("[max]").change(function () {
      var max = parseInt($(this).attr("max"), 10);
      var value = parseInt($(this).val(), 10) || 0;
      if (value > max) {
        alert("We only have " + max + " of this item in stock");
        $(this).val(max);
      }
    });
  }

  $(".product__add-to-cart-button, .site-header__cart").click(function () {
    var minOrderMessage = $(".minimum-order-note__container");
    var checkoutButton = $(".cart-drawer__checkout");
    var subTotal = parseInt(
      $(".cart-drawer__subtotal-number").text().replace(/\$/, ""),
      10
    );

    if (subTotal < 45) {
      minOrderMessage.show();
      checkoutButton.hide();
    }

    if (subTotal >= 45) {
      minOrderMessage.hide();
      checkoutButton.show();
    }
  });

  function checkCart() {
    intervalID = setInterval(updateCartDisplay, 650);
  }

  function updateCartDisplay() {
    var minOrderContainer = $(".minimum-order-note__container");
    var cartDrawerCheckoutButton = $(".cart-drawer__checkout");
    var currentSubTotal = parseInt(
      $(".cart-drawer__subtotal-number").text().replace(/\$/, ""),
      10
    );

    console.log(currentSubTotal);

    if (currentSubTotal < 24) {
      minOrderContainer.show();
      cartDrawerCheckoutButton.hide();
    }

    if (currentSubTotal >= 24) {
      minOrderContainer.hide();
      cartDrawerCheckoutButton.show();
    }
  }

  checkCart();
});

/* Added by Nicole M @ Shopify TS on August 13, 2018 */

var sections = window.theme.sections;

var showLoadedVideo = {
  init: function () {
    // Assign 'variant_change' event handler
    this.on("slideshow_video_load", this._showVideoSlide.bind(this));
  },

  _showVideoSlide: function (event, instance, product, variant) {
    var self = this;
    setTimeout(function () {
      self.$slide.addClass("slideshow__video--loaded");
    }, 500);
  },
};

sections.extend("slideshow-section", showLoadedVideo);
